import {QueryErrorResetBoundary} from '@github-ui/react-query'
import {createContext, type ReactNode, use} from 'react'

export type ActivityCommentJump = {
  activationId: number
  focusText: `issuecomment-${number}`
  returnFocus: HTMLButtonElement
  source: 'comment-menu'
}

type ActivityPanelContextValue = {
  closePanel: () => void
  open: boolean
  openPanel: (commentJump?: ActivityCommentJump) => void
  panelTarget: HTMLElement | null
  commentJump?: ActivityCommentJump
}

export const ActivityPanelContext = createContext<ActivityPanelContextValue | null>(null)

export function useActivityPanel() {
  const context = use(ActivityPanelContext)
  if (!context) throw new Error('useActivityPanel must be used within an ActivityPanelContext')
  return context
}

export function ActivityPanelProvider({children, value}: {children: ReactNode; value: ActivityPanelContextValue}) {
  return (
    <QueryErrorResetBoundary>
      <ActivityPanelContext value={value}>{children}</ActivityPanelContext>
    </QueryErrorResetBoundary>
  )
}
